import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { tokens } from '@cellula/react-theme-patient';
import { AnimatePresence, motion } from 'framer-motion';
import styled from 'styled-components';

interface Props {
	show: boolean;
	onClick: () => void;
}

const elements = {
	container: styled.div`
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		display: flex;
		height: 60px;
		justify-content: center;
		align-items: center;
		z-index: 1;
		pointer-events: none;
	`,
	button: styled(motion.button)`
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		all: unset;
		display: flex;
		justify-content: center;
		background-color: ${tokens.color.bg.surface};
		padding: ${tokens.size.x1} ${tokens.size.x3};
		font: ${tokens.text.label.largeSemiBold};
		color: ${tokens.color.content.interactive};
		border-radius: ${tokens.borderRadius.pill};
		box-shadow: ${tokens.elevation.floating};
		border: 2px solid ${tokens.color.content.interactive};
		user-select: none;
		transition: box-shadow 150ms ease-in;
		overflow: hidden;
		position: relative;
		pointer-events: all;

		&::after {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			transition: background-color 150ms ease-in;
			z-index: -1;
		}

		&:hover {
			&::after {
				background-color: ${tokens.color.bg.interactiveMutedHover};
			}
		}

		&:active {
			&::after {
				background-color: ${tokens.color.bg.interactiveMutedActive};
			}
		}
	`,
};

export function NewMessageFloatingButton({ show, onClick }: Props): JSX.Element {
	const analyticCtx = useAnalyticContext();

	function handleClick(): void {
		analyticCtx.trackEvent('Clicked scroll to bottom arrow');

		onClick();
	}

	return (
		<elements.container aria-hidden tabIndex={-1}>
			<AnimatePresence>
				{show ? (
					<elements.button
						initial={{ y: 100 }}
						animate={{ y: 0 }}
						exit={{ y: 100, scale: 0 }}
						whileHover={{
							scale: 1.1,
						}}
						whileTap={{
							scale: 0.98,
						}}
						onClick={handleClick}
					>
						{withTranslation('PW.Component.Chat.NewMessagesButton')}
					</elements.button>
				) : null}
			</AnimatePresence>
		</elements.container>
	);
}
